import Bootstrap from 'bootstrap/dist/css/bootstrap.css';
import 'babel-polyfill';
import App from './App.vue';

new App().$mount('#oe1-app');
